import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { T } from '../../lib/i18n';
import { badge, riskColor, activity } from '../../lib/format';
import { card, cardPad } from '../../lib/ui';

export default function Dashboard() {
  const { state, go, L } = useApp();
  const t = T(state.lang);

  const kpis = [
    { label: L('Incoming PRs', 'ใบขอซื้อที่เข้ามา'), value: '2', icon: 'inbox', go: () => go('incoming') },
    { label: L('Active RFQs', 'ใบขอเสนอราคา(RFQ) ที่ใช้งาน'), value: '3', icon: 'file-text', go: () => go('rfq') },
    { label: L('Pending Approvals', 'รออนุมัติ'), value: '3', icon: 'pen-tool', go: () => go('doa') },
    { label: L('Supplier Reviews', 'การตรวจสอบซัพพลายเออร์'), value: '3', icon: 'user-check', go: () => go('review') },
  ];
  const stats = [
    { label: L('Total Spend (Awarded)', 'ยอดใช้จ่ายรวม (มอบสัญญาแล้ว)'), value: '$26.5M', sub: 'FY 2026' },
    { label: L('Active Suppliers (ASL)', 'ซัพพลายเออร์ที่ใช้งาน (ASL)'), value: '6', sub: L('of 9 total', 'จาก 9 ทั้งหมด') },
    { label: L('RFQs Closed This Month', 'RFQ ที่ปิดเดือนนี้'), value: '2', sub: L('of 6 total', 'จาก 6 ทั้งหมด') },
  ];
  const activeRfqs = [
    { title: 'Fleet Vehicle Insurance — Class 1 Batch', id: 'RFQ-2026-001', deadline: '2026-06-20', bids: '3/4 bids', value: '$4.85M', risk: 12, go: () => go('bidcompare') },
    { title: 'Fleet Vehicle Insurance — Class 2 & 3', id: 'RFQ-2026-004', deadline: '2026-06-28', bids: '2/4 bids', value: '$7.2M', risk: 72, go: () => go('rfq') },
    { title: 'Spare Parts Procurement — Quarterly Q2', id: 'RFQ-2026-002', deadline: '2026-06-15', bids: '5/6 bids', value: '$12.4M', risk: 41, go: () => go('rfq') },
  ];
  const recent = [
    activity('check', 'ok', L('Award confirmed to Apex Insurance Co. on RFQ-2026-005', 'ยืนยันมอบสัญญาให้ Apex Insurance Co. บน RFQ-2026-005'), '2h ago'),
    activity('inbox', 'info', L('New PR received: PR-2026-0187 — GPS Tracking Devices', 'ได้รับใบขอซื้อ(PR) ใหม่: PR-2026-0187 — GPS Tracking Devices'), '4h ago'),
    activity('user-check', 'info', L('Northgate Insurance registered — pending review', 'Northgate Insurance ลงทะเบียนแล้ว — รอตรวจสอบ'), '6h ago'),
    activity('alert-triangle', 'alert', L('Collusion flagged on RFQ-2026-004 — score 72', 'ตรวจพบสัญญาณสมรู้ร่วมคิดบน RFQ-2026-004 — คะแนน 72'), '8h ago'),
    activity('receipt', 'ok', L('3-way match completed for PO-2026-0035', 'จับคู่ 3 ทางสำเร็จสำหรับ PO-2026-0035'), '1d ago'),
    activity('pen-tool', 'action', L('DOA approval pending — PO-2026-0041 $4.62M', 'รออนุมัติ DOA — PO-2026-0041 $4.62M'), '1d ago'),
  ];
  const reviews = [
    { initial: 'OM', name: 'Orion Marine Insurance', cat: 'Insurance · Tier 2', status: 'Pending' },
    { initial: 'GT', name: 'GeoTrack Solutions', cat: 'IT & Office', status: 'Under Review' },
    { initial: 'NI', name: 'Northgate Insurance', cat: 'Insurance', status: 'Pending' },
  ];
  const expiring = [
    { name: 'Spare Parts Supply — Annual', id: 'CON-2025-0058', color: 'var(--color-error)', days: '21 days' },
    { name: 'Property All-Risk Cover', id: 'CON-2026-0009', color: 'var(--color-warning)', days: '70 days' },
  ];

  return (
    <>
      <div data-tour="kpis" className="kpi-strip" style={{ marginBottom: 16 }}>
        {kpis.map((k) => (
          <button key={k.label} onClick={k.go}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}><span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{k.label}</span><Icon name={k.icon} style={{ color: 'var(--color-primary)', fontSize: 18 }} /></div>
            <div style={{ fontSize: 30, fontWeight: 700, fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums', letterSpacing: '-.02em' }}>{k.value}</div>
          </button>
        ))}
      </div>

      <div className="dash-stats" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 16 }}>
        {stats.map((s) => (
          <div key={s.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{s.label}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}><span style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{s.value}</span><span style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{s.sub}</span></div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div data-tour="rfqs" style={cardPad(20)}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>{t.activeRfqs}</div>
          {activeRfqs.map((r) => (
            <button key={r.id} className="hv-mist" onClick={r.go} style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderRadius: 'var(--radius-sm)', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 600, marginBottom: 3 }}>{r.title}</div><div style={{ fontSize: 11, color: 'var(--color-fg-3)', fontFamily: 'var(--font-mono)' }}>{r.id} · {r.deadline} · {r.bids}</div></div>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{r.value}</div><div style={{ fontSize: 11, fontWeight: 600, color: riskColor(r.risk) }}>{L('Risk', 'ความเสี่ยง')}: {r.risk}</div></div>
            </button>
          ))}
        </div>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>{t.recentActivity}</div>
          {recent.map((a, i) => (
            <div key={i} style={{ display: 'flex', gap: 11, padding: '9px 0', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ width: 26, height: 26, flex: 'none', borderRadius: 999, background: a.bg, color: a.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}><Icon name={a.icon} /></div>
              <div style={{ flex: 1 }}><div style={{ fontSize: 13, lineHeight: 1.4 }}>{a.text}</div><div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{a.time}</div></div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>{t.supplierReviews}</div>
          {reviews.map((s) => {
            const b = badge(s.status);
            return (
              <div key={s.name} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '10px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ width: 32, height: 32, borderRadius: 999, background: 'var(--color-ink-50)', color: 'var(--color-fg-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{s.initial}</span>
                <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 600 }}>{s.name}</div><div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{s.cat}</div></div>
                <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 999, background: b.bg, color: b.fg }}>{s.status}</span>
              </div>
            );
          })}
        </div>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>{t.expiringContracts}</div>
          {expiring.map((c) => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '10px 0', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 600 }}>{c.name}</div><div style={{ fontSize: 11, color: 'var(--color-fg-3)', fontFamily: 'var(--font-mono)' }}>{c.id}</div></div>
              <span style={{ fontSize: 12, fontWeight: 700, color: c.color }}>{c.days}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
